var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Smarter screening across Africa")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Asoko Projects is our on-demand service that acts as an extension of your risk and compliance teams, enabling them to more efficiently mitigate risk through company verification and bespoke research across Africa. Retrieve public and litigation records on company shareholders and directors to verify ownership and control for compliance and  KYC assessments on a project-by-project basis."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }